var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processing"},[_c('circle-stage',[_c('template',{slot:"headline"},[_vm._v(" "+_vm._s(_vm.$t('Processing.headline'))+" "),_c('loading-icon')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }